import React, { useEffect, useState } from "react";
import { Modal, Spinner } from "react-bootstrap";
import { useSelector, shallowEqual } from "react-redux";
import axios from "axios";
import CallDetailsTabs from "../../calldetails/components/CallDetailsTabs";

const QuoteCallDetailsModal = ({ show, onHide, quoteId }) => {
  const { cdnURL, adminBaseURL } = useSelector(
    (state) => state.environnment.environmentLists,
    shallowEqual
  );

  const [isLoading, setIsLoading] = useState(false);
  const [quoteObj, setQuoteObj] = useState({});
  const [callItems, setCallItems] = useState([]);

  useEffect(() => {
    if (!show || !quoteId) return;

    let mounted = true;
    (async () => {
      try {
        setIsLoading(true);
        const { data } = await axios({
          method: "GET",
          url: `${process.env.REACT_APP_HOST}${adminBaseURL}/quote/getCallDetailsQuote/${quoteId}`,
          headers: { "Content-Type": "application/json" },
        });

        if (!mounted) return;
        if (data && data.code === 200 && data.data) {
          setQuoteObj(data.data.quote || {});
          setCallItems(Array.isArray(data.data.call_ai) ? data.data.call_ai : []);
        } else {
          setQuoteObj({});
          setCallItems([]);
        }
      } catch (error) {
        if (!mounted) return;
        setQuoteObj({});
        setCallItems([]);
      } finally {
        if (mounted) setIsLoading(false);
      }
    })();

    return () => {
      mounted = false;
    };
  }, [show, quoteId, adminBaseURL]);

  return (
    <>
      <Modal
        show={show}
        onHide={onHide}
        fullscreen
        scrollable
        centered
        dialogClassName="quote-call-details-dialog"
        contentClassName="h-100"
      >
        <Modal.Header className="d-flex justify-content-between align-items-center">
          <Modal.Title className="mb-0">Quote Call Details</Modal.Title>
          <button
            type="button"
            className="btn btn-link p-0"
            onClick={onHide}
            aria-label="Close"
            style={{ fontSize: 24, lineHeight: 1, color: "#6b7280", textDecoration: "none" }}
          >
            ×
          </button>
        </Modal.Header>
        <Modal.Body
          style={{
            background: "#f8fafc",
            display: "flex",
            flexDirection: "column",
            gap: 16,
            minHeight: "80vh", // keep full height to prevent flicker while loading
          }}
        >
          {isLoading ? (
            <div className="d-flex justify-content-center align-items-center" style={{ minHeight: "200px" }}>
              <Spinner animation="border" />
            </div>
          ) : (
            <div style={{ display: "flex", flexDirection: "column", gap: 16, minHeight: 0 }}>
              <div
                style={{
                  background: "#ffffff",
                  borderRadius: 12,
                  border: "1px solid #e5e7eb",
                  padding: "16px 20px",
                  display: "grid",
                  gridTemplateColumns: "repeat(auto-fit, minmax(140px, 1fr))",
                  gap: 12,
                }}
              >
                <div>
                  <div style={{ fontSize: 12, color: "#6b7280", marginBottom: 4 }}>Name</div>
                  <div style={{ fontWeight: 600, color: "#111827" }}>{quoteObj?.name || "-"}</div>
                </div>
                <div>
                  <div style={{ fontSize: 12, color: "#6b7280", marginBottom: 4 }}>Email</div>
                  <div style={{ fontWeight: 600, color: "#111827" }}>{quoteObj?.email || "-"}</div>
                </div>
                <div>
                  <div style={{ fontSize: 12, color: "#6b7280", marginBottom: 4 }}>Mobile</div>
                  <div style={{ fontWeight: 600, color: "#111827" }}>{quoteObj?.contactNumber || "-"}</div>
                </div>
                {quoteObj?.countryName && (
                  <div>
                    <div style={{ fontSize: 12, color: "#6b7280", marginBottom: 4 }}>Country</div>
                    <div style={{ fontWeight: 600, color: "#111827" }}>{quoteObj?.countryName}</div>
                  </div>
                )}
                {quoteObj?.currentCountryTime && (
                  <div>
                    <div style={{ fontSize: 12, color: "#6b7280", marginBottom: 4 }}>Current Time</div>
                    <div style={{ fontWeight: 600, color: "#111827" }}>{quoteObj?.currentCountryTime}</div>
                  </div>
                )}
              </div>

              <div
                style={{
                  background: "#ffffff",
                  borderRadius: 12,
                  border: "1px solid #e5e7eb",
                  flex: 1,
                  minHeight: 0,
                  display: "flex",
                  flexDirection: "column",
                }}
              >
                <CallDetailsTabs
                  callItems={callItems}
                  cdnURL={cdnURL}
                  emptyMessage="No AI call records available for this quote."
                />
              </div>
            </div>
          )}
        </Modal.Body>
      </Modal>
      <style>{`
        .quote-call-details-dialog {
          max-width: 98% !important;
          width: 98%;
        }
      `}</style>
    </>
  );
};

export default QuoteCallDetailsModal;

